<mat-card class="menupannel">
    <div class="resUser">
      <button mat-flat-button (click)="showMyDrive()">
        My Process 
      </button>
    </div>
    <div class="d">
      <button mat-flat-button (click)="showDocDetail()">
        <mat-icon>keyboard_arrow_left</mat-icon> Details
      </button> 
    </div>
</mat-card >

  <div class="coreholder" fxLayout="row">
    <!-- My Drive -->
    <mat-card  class="myDrive" [ngClass]="{'open': showmyDrive }">
  
      <div class="createdfolder">
  

  
        <div class="drive">
          <div class="header">
            <div class="nameNcount">
              <h3>My Process</h3>
              <!-- <span class="count">3</span> -->
            </div>
            <div class="add">
              <button mat-icon-button color="primary" >
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div>
          </div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl"  >
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
              <!-- use a disabled button to provide padding for tree leaf -->
                <div class="folderName">
                  <mat-icon>folder</mat-icon> <span class="flname" >{{node.name}}</span>
                </div>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow"  matTreeNodeToggle
                      [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon>folder</mat-icon> <span class="flname" >{{node.name}}</span>
                </div>
              </div>
              
            </mat-tree-node>
          </mat-tree>
        </div>

        <div class="drive">
          <div class="header">
            <div class="nameNcount">
              <h3>Process shared with me</h3>
              <!-- <span class="count">3</span> -->
            </div>
            <!-- <div class="add">
              <button mat-icon-button color="primary" >
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div> -->
          </div>
          <div class="folderName">
            <mat-icon>folder</mat-icon> <span class="flname" >Patient</span>
          </div>
        </div>

        <div class="drive">
          <div class="header">
            <div class="nameNcount">
              <h3>My Templates</h3>
              <!-- <span class="count">3</span> -->
            </div>
            <div class="add">
              <button mat-icon-button color="primary" >
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div>
          </div>
          <div class="folderName">
            <mat-icon>folder</mat-icon> <span class="flname" >Patient</span>
          </div>
        </div>

        <div class="drive">
          <div class="header">
            <div class="nameNcount">
              <h3>Template shared with me</h3>
              <!-- <span class="count">3</span> -->
            </div>
            <!-- <div class="add">
              <button mat-icon-button color="primary" >
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div> -->
          </div>
          <div class="folderName">
            <mat-icon>folder</mat-icon> <span class="flname" >Patient</span>
          </div>
        </div>


      </div>
  
     
  
    </mat-card >
    <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{'open': showmyDrive }"></div>
    <!-- My Drive -->
  
    <!-- Core page Structure -->
    <div class="corepages">
  
      <!-- Filter -->
      <mat-card  class="filter">
        <mat-form-field appearance="fill" >
          <mat-label>Search items in folder </mat-label>
          <input matInput type="text"  maxlength="30">
          <button matSuffix mat-icon-button aria-label="Clear" >
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
  
        <button  class="sortfilter"   mat-icon-button >
          <mat-icon>filter_list</mat-icon>
        </button>
        <button class="create" [routerLink]="'/intelligence/canvas'" mat-flat-button color="primary" > Create New  </button>
      </mat-card >
      <!-- Filter -->
  
      <!-- Selected Folder-->
  
        <!-- <div class="selectedFolder">
          
          <div class="selctfol">
          <div class="folname">
            <mat-icon>folder</mat-icon> Core
          </div>
          <button mat-button color="primary" > <mat-icon>add</mat-icon> Add Folder</button>
          <button mat-button color="primary" > <mat-icon>add</mat-icon> Add File</button>
          </div>
    
          <div class="act">
            <button mat-icon-button color="basic"><mat-icon>person_add</mat-icon></button>
            <button mat-icon-button color="basic" class="edit" ><mat-icon>edit</mat-icon></button>
            <button mat-icon-button color="basic" class="trash" ><mat-icon>delete</mat-icon></button>
          </div>
    
        </div> -->
  
      <!-- Selected Folder -->

      <div class="folders">
        <div class="heading">
          <span>Recent Viewed</span>
          <!-- <a href="javascript:void(0)">View all</a> -->
        </div>
        <div class="allfolder">
          <mat-card  class="folder">
            <div class="iconUser">
             <div class="docType"> <mat-icon>folder</mat-icon> </div>
              <div class="userlist">
                <div class="user" matTooltipClass="tooltip" matTooltip="Emmalene"><img
                    src="../../../assets/images/avatars/Katina.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Chelsea"><img
                    src="../../../assets/images/avatars/Nancy.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Taylor"><img
                    src="../../../assets/images/avatars/Shauna.jpg" alt=""></div>
                <div class="userCount" matTooltipClass="tooltip">+14</div>
              </div>
            </div>
            <h4>Core</h4>
            <div class="countshare">
              <span class="filecount">526 files</span>
              <button mat-icon-button (click)="addFolder(addFolderDialog)">
                <mat-icon>person_add</mat-icon>
              </button>
            </div>
          </mat-card >
          <mat-card  class="folder">
            <div class="iconUser">
              <div class="docType"> <mat-icon>folder</mat-icon> </div>
              <div class="userlist">
                <div class="user" matTooltipClass="tooltip" matTooltip="Emmalene"><img
                    src="../../../assets/images/avatars/Katina.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Chelsea"><img
                    src="../../../assets/images/avatars/Nancy.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Taylor"><img
                    src="../../../assets/images/avatars/Shauna.jpg" alt=""></div>
                <div class="userCount" matTooltipClass="tooltip">+14</div>
              </div>
            </div>
            <h4>Agreement</h4>
            <div class="countshare">
              <span class="filecount">526 files</span>
              <button mat-icon-button (click)="addFolder(addFolderDialog)">
                <mat-icon>person_add</mat-icon>
              </button>
            </div>
          </mat-card >
          <mat-card  class="folder">
            <div class="iconUser">
              <div class="docType"> <mat-icon>folder</mat-icon> </div>
              <div class="userlist">
                <div class="user" matTooltipClass="tooltip" matTooltip="Emmalene"><img
                    src="../../../assets/images/avatars/Katina.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Chelsea"><img
                    src="../../../assets/images/avatars/Nancy.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Taylor"><img
                    src="../../../assets/images/avatars/Shauna.jpg" alt=""></div>
                <div class="userCount" matTooltipClass="tooltip">+14</div>
              </div>
            </div>
            <h4>Hospital</h4>
            <div class="countshare">
              <span class="filecount">526 files</span>
              <button mat-icon-button>
                <mat-icon>person_add</mat-icon>
              </button>
            </div>
          </mat-card >
          <mat-card  class="folder">
            <div class="iconUser">
              <div class="docType"> <mat-icon>folder</mat-icon> </div>
              <div class="userlist">
                <div class="user" matTooltipClass="tooltip" matTooltip="Emmalene"><img
                    src="../../../assets/images/avatars/Katina.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Chelsea"><img
                    src="../../../assets/images/avatars/Nancy.jpg" alt=""></div>
                <div class="user" matTooltipClass="tooltip" matTooltip="Taylor"><img
                    src="../../../assets/images/avatars/Shauna.jpg" alt=""></div>
                <div class="userCount" matTooltipClass="tooltip">+14</div>
              </div>
            </div>
            <h4>Personal</h4>
            <div class="countshare">
              <span class="filecount">526 files</span>
              <button mat-icon-button>
                <mat-icon>person_add</mat-icon>
              </button>
            </div>
          </mat-card >
  
        </div>
      </div>
  
      <div class="breadcumb">
        <span>Core</span> <mat-icon>navigate_next</mat-icon>
        <span class="current" >Admission</span>
        <span class="" >
          <button mat-icon-button class="createNew" color="primary"  (click)="createFolders(createFolder)" >
            <mat-icon>create_new_folder</mat-icon>
          </button>
        </span>
        
      </div>

      <mat-card class="files">
        <table class="mat-table">
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell"> <span class="checkbo"><mat-checkbox color="primary" ></mat-checkbox></span> </th>
              <th class="mat-header-cell"></th>
              <th class="mat-header-cell">Name</th>
              <th class="mat-header-cell">Modified On</th>
              <th class="mat-header-cell">Owner</th>
              <th class="mat-header-cell">Created On</th>
              <th class="mat-header-cell shareIcon">&nbsp;</th>
              <th class="mat-header-cell action">Action</th>
            </tr>
          </thead>
          <tbody>

            <tr class="mat-row foldericon">
              <td class="mat-cell"><span class="checkbo"><mat-checkbox color="primary" ></mat-checkbox></span></td>
              <td class="mat-cell docType " ><mat-icon>folder</mat-icon></td>
              <td class="mat-cell"><span class="formName" matTooltipClass="tooltip" matTooltip="Public Document">Real Estate</span>
              </td>
              <td class="mat-cell">4/6/2020, 5:28 PM</td>
              <td class="mat-cell">Emily Bennett</td>
              <td class="mat-cell">11/05/20</td>
              <td class="mat-cell">  <button class="shareFileFol" mat-icon-button > <mat-icon>share</mat-icon> </button>
              </td>
              <td class="mat-cell">
                  <div class="act">                  
                    <button mat-icon-button [matMenuTriggerFor]="folder" >
                      <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #folder="matMenu" xPosition="before">
                      <button mat-menu-item> <mat-icon>folder_open</mat-icon> Open</button>                      
                      <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button>
                      <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
                    </mat-menu>
                  </div>
              </td>
            </tr>
            <tr class="mat-row foldericon">
              <td class="mat-cell"><span class="checkbo"><mat-checkbox color="primary" ></mat-checkbox></span></td>
              <td class="mat-cell docType " ><mat-icon>folder</mat-icon></td>
              <td class="mat-cell"><span class="formName" matTooltipClass="tooltip" matTooltip="Public Document">HR & Training</span>
              </td>
              <td class="mat-cell">4/6/2020, 5:28 PM</td>
              <td class="mat-cell">Emily Bennett</td>
              <td class="mat-cell">11/05/20</td>
              <td class="mat-cell">  <button class="shareFileFol" mat-icon-button > <mat-icon>share</mat-icon> </button>
              <td class="mat-cell">
               
                  <div class="act">                  
                    <button mat-icon-button [matMenuTriggerFor]="folder" >
                      <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #folder="matMenu" xPosition="before">
                      <button mat-menu-item> <mat-icon>folder_open</mat-icon> Open</button>                      
                      <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button>
                      <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
                    </mat-menu>
                  </div>
            
              </td>
            </tr>

            <tr class="mat-row documentRow">
              <td class="mat-cell"><span class="checkbo"><mat-checkbox color="primary" ></mat-checkbox></span></td>
              <td class="mat-cell docType " > <mat-icon>description</mat-icon> </td>
              <td class="mat-cell"><span class="formName" matTooltipClass="tooltip" matTooltip="Public Document" [routerLink]="'/esignature/canvas'" >Admission Skin Checksheet 3 Form</span>
              </td>
              <td class="mat-cell">14/11/2019, 5:28 PM</td>
              <td class="mat-cell">Emily Bennett</td>
              <td class="mat-cell">11/05/20</td>
              <td class="mat-cell">  <button class="shareFileFol" mat-icon-button > <mat-icon>share</mat-icon> </button>
              <td class="mat-cell">
                <div class="act">                  
                  <button mat-icon-button [matMenuTriggerFor]="menu" >
                    <mat-icon>more_vertical</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item> <mat-icon>link</mat-icon> URL</button>
                    <button mat-menu-item><mat-icon>format_shapes </mat-icon> Edit</button>
                    <button mat-menu-item><mat-icon>create</mat-icon> Sign</button>
                    <button mat-menu-item> <mat-icon>assignment</mat-icon> Fill</button>
                    <button mat-menu-item><mat-icon>supervised_user_circle</mat-icon> File Access</button>
                    <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button>
                    <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
                  </mat-menu>
                </div>
              </td>
            </tr>
            <tr class="mat-row documentRow">
              <td class="mat-cell"><span class="checkbo"><mat-checkbox color="primary" ></mat-checkbox></span></td>
              <td class="mat-cell docType " ><mat-icon>description</mat-icon></td>
              <td class="mat-cell"><span class="formName" matTooltipClass="tooltip" matTooltip="Public Document" [routerLink]="'/esignature/canvas'">Verification of Informed Consent for Psych Meds Form</span>
              </td>
              <td class="mat-cell">4/6/2020, 5:28 PM</td>
              <td class="mat-cell">Emily Bennett</td>
              <td class="mat-cell">11/05/20</td>
              <td class="mat-cell">  <button class="shareFileFol" mat-icon-button > <mat-icon>share</mat-icon> </button>
              <td class="mat-cell">
                <div class="act">                  
                  <button mat-icon-button [matMenuTriggerFor]="menu" >
                    <mat-icon>more_vertical</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item> <mat-icon>link</mat-icon> URL</button>
                    <button mat-menu-item><mat-icon>format_shapes </mat-icon> Edit</button>
                    <button mat-menu-item><mat-icon>create</mat-icon> Sign</button>
                    <button mat-menu-item> <mat-icon>assignment</mat-icon> Fill</button>
                    <button mat-menu-item><mat-icon>supervised_user_circle</mat-icon> File Access</button>
                    <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button>
                    <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
                  </mat-menu>
                </div>
              </td>
            </tr>
            
          </tbody>
        </table>
      </mat-card>
    </div>
    <!-- Core page Structure -->
    <!-- Document Detail  -->
    <mat-card  class="documentDetail" [ngClass]="{'open': docDetail }">
  
      <div class="folderInDetail">
        <div class="iconUser">
          <mat-icon>folder</mat-icon>
          <div class="nmFile">
            <h4>Admission</h4>
            <span class="filecount">526 Forms</span>
          </div>
        </div>
        <div class="">
          <button mat-icon-button [matMenuTriggerFor]="mainfolder" >
            <mat-icon>more_vertical</mat-icon>
          </button>
          <mat-menu #mainfolder="matMenu" xPosition="before">                    
            <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button>
            <button mat-menu-item><mat-icon>delete_outline</mat-icon> Delete</button>
          </mat-menu>
        </div>
        
      </div>
  
      <div class="fileTypecount">
        <!-- <div class="typefile">
          <span><img src="../../../assets/images/icons/word.png" alt=""></span>
          <span>58 Files</span>
        </div>
        <div class="typefile">
          <span><img src="../../../assets/images/icons/excel.png" alt=""></span>
          <span>58 Files</span>
        </div>
        <div class="typefile">
          <span><img src="../../../assets/images/icons/pdf.png" alt=""></span>
          <span>58 Files</span>
        </div>
        <div class="typefile">
          <span><img src="../../../assets/images/icons/other.png" alt=""></span>
          <span>58 Files</span>
        </div> -->
        <div class="userlist">
          <div class="user"><img src="../../../assets/images/avatars/Katina.jpg" alt=""></div>
          <div class="user"><img src="../../../assets/images/avatars/Nancy.jpg" alt=""></div>
          <div class="user"><img src="../../../assets/images/avatars/Shauna.jpg" alt=""></div>
          <!-- +14 -->
          <div class="userCount">
            <button mat-icon-button (click)="addFolder(addFolderDialog)" >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
  
  
      <div class="docDetail">
  
        <!--  If there is not selected any document or file -->
        <!-- <div class="notselected">
          <mat-icon>speaker_notes_off</mat-icon>
          <p>Select a file or folder to view its details</p>
        </div> -->
        <!--  If there is not selected any document or file -->
  
        <div class="metadetails">
          <div class="info meta">
            <p><span>Type</span>Folder</p>
            <p><span>Size</span>52 kb</p>
            <p><span>Created Date</span>20/07/1988</p>
          </div>
  
  
          <div class="history">
            <div class="title">
              <div class="head">
                <h3>Note </h3>
                <span class="count">1</span>
              </div>
  
              <button mat-icon-button color="primary" (click)="addNewNote()" [ngClass]="{'active':  addNote }">
                <mat-icon>add</mat-icon>
              </button>
            </div>
  
            <div class="addnote" *ngIf="addNote">
  
              <div class="holder">
                <mat-form-field class="">
                  <mat-label>Add note</mat-label>
                  <textarea matInput placeholder="Write Note..."></textarea>
                </mat-form-field>
  
                <div class="btns">
                  <button mat-button color="">Cancel</button>
                  <button mat-button color="primary">Save</button>
                </div>
              </div>
  
            </div>
  
  
            <div class="historylist">
              <div class="list">
                <div class="noteby">
                  <p class="by">HankPym <span>11/30/2018</span></p>
                  <p>When two parties reach an agreement on a transaction
                    that gives one party the capital to purchase a home or
                    other form of property</p>
                </div>
                <button mat-icon-button>
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
    </mat-card >
    <div class="documentDetailOverlay" (click)="showDocDetail()" [ngClass]="{'open': docDetail }"></div>
    <!-- Document Detail -->
  
  </div>
  
  

  <ng-template #createFolder>
    <h2 matDialogTitle>Create Folder</h2>
    <mat-dialog-content>
      <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput  placeholder="Add folder name"
          value="" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button  color="" >Close</button>
      <button mat-button  color="primary">
        Create
      </button>
    </mat-dialog-actions>
  </ng-template>

  
  <ng-template #addFolderDialog>
    <h2 mat-dialog-title>
       <span class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Share with Contact and Role 
        
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">

  
    <mat-form-field  appearance="fill">
      <input matInput
             placeholder="Add Contact or Role"
             aria-label="State"
             [matAutocomplete]="auto"
             [formControl]="stateCtrl">
      <mat-autocomplete #auto="matAutocomplete" >
        <mat-option  *ngFor="let state of filteredStates | async" [value]="state.name">
          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center" >
              <div class="pic">
                  <img class="" [src]="state.pic"/>
              </div>
              <span fxLayout="column" fxLayoutAlign="flex-start" > 
                  <b>{{state.name}} </b>
                  <small>{{state.email}}</small>
              </span> 
          </span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  
  
    <ul class="selectedlist" >
      
      <li *ngFor="let user of peoples" >
        <div class="userndetail">
            <div class="pic">
              <img src="../../../assets/images/avatars/{{user.img}}" alt="" >
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
        </div>
        <div class="option">
          <button mat-flat-button [matMenuTriggerFor]="menu"  aria-label="Permission">
            <mat-icon>visibility</mat-icon>Viewer
          </button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button disabled mat-menu-item>
              <mat-icon>visibility</mat-icon>
              <span>Viewer</span>
            </button>
            <button mat-menu-item >
              <mat-icon>text_fields</mat-icon>
              <span>Editor</span>
            </button>
            <button mat-menu-item>
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </div>
      </li>
     
    </ul>
  
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" >Done</button>
  </mat-dialog-actions>
  </ng-template>